import { getAppConfig } from '@services/config';

const appConfig = getAppConfig();

export enum PAGE_SLUG {
    FAI_HOME = 'offres-internet',
    ELIGIBILITY = 'offres-internet_test-eligibilite',
    PACK = 'offres-internet_combo-box',
    PACK_GAMING = 'offres-internet_bbox-gaming',
    PACK_GAMING_PS5 = 'offres-internet_bbox-gaming-ps5',
    PACK_SMART_TV = 'offres-internet_bbox-smart-tv',
    PACK_TABLET = 'offres-internet_bbox-tablette',
    BOX_5G = 'offres-internet_5g-box',
    BOX5G = 'offres-internet_5gbox',
    EXTRA_BBOX = 'offres-internet_extra-bbox',
    BIG_HOME = 'offres-box-forfait',
    PHONE_WALL = 'telephones-mobiles',
    PHONE_WALL_RENEWAL = 'telephones-mobiles_renouvellement',
    ACCESSORY_WALL = 'accessoires',
    PHONE_PRODUCT = 'telephones-mobiles_produit',
    PHONE_PRODUCT_RENEWAL = 'telephones-mobiles_produit_renouvellement',
    ACCESSORY_PRODUCT = 'accessoires_produit',
    OFFER_WALL = 'forfaits-mobiles_avec-engagement',
    CROSS_SELL = 'personnaliser-mon-offre',
    INTEREST_FORM = 'prise-interet',
    RECALL = 'rappelez-moi',
    BYOU = 'forfaits-mobiles_sans-engagement',
    SALES_WALL_PHONE = 'bons-plans_telephones',
    SALES_WALL_ACCESSORY = 'bons-plans_accessoires',
    ODR_WALL = 'offres-de-remboursement',
    HOTSPOT = 'hotspot-tablette',
    KIDS_WATCH = 'kids-watch',
}

export type FaqSlugType =
    | PAGE_SLUG.FAI_HOME
    | PAGE_SLUG.ELIGIBILITY
    | PAGE_SLUG.PACK_GAMING
    | PAGE_SLUG.PACK_GAMING_PS5
    | PAGE_SLUG.PACK_SMART_TV
    | PAGE_SLUG.PACK_TABLET
    | PAGE_SLUG.BIG_HOME
    | PAGE_SLUG.OFFER_WALL
    | PAGE_SLUG.PHONE_WALL
    | PAGE_SLUG.BOX5G
    | PAGE_SLUG.EXTRA_BBOX
    | `telephones-mobiles_filtre_${string}`
    | 'byou-fai'
    | 'offres-internet_nrj'
    | 'offres-internet_cdiscount'
    | 'offres-internet_auchan'
    | 'kids-watch';

export type LegalsSlugType =
    | PAGE_SLUG.FAI_HOME
    | PAGE_SLUG.ELIGIBILITY // Post eligibility
    | PAGE_SLUG.PACK
    | PAGE_SLUG.BOX_5G
    | PAGE_SLUG.BIG_HOME
    | PAGE_SLUG.PHONE_WALL
    | PAGE_SLUG.ACCESSORY_WALL
    | PAGE_SLUG.PHONE_PRODUCT
    | PAGE_SLUG.PHONE_PRODUCT_RENEWAL
    | PAGE_SLUG.ACCESSORY_PRODUCT
    | PAGE_SLUG.OFFER_WALL
    | PAGE_SLUG.RECALL
    | PAGE_SLUG.BYOU
    | PAGE_SLUG.HOTSPOT
    | 'offres-internet_nrj'
    | 'offres-internet_cdiscount'
    | 'offres-internet_auchan'
    | 'kids-watch';

export type BannerSlugType =
    | PAGE_SLUG.FAI_HOME
    | PAGE_SLUG.ELIGIBILITY
    | PAGE_SLUG.PACK
    | PAGE_SLUG.BIG_HOME
    | PAGE_SLUG.PHONE_WALL
    | PAGE_SLUG.PHONE_WALL_RENEWAL
    | PAGE_SLUG.ACCESSORY_WALL
    | PAGE_SLUG.CROSS_SELL
    | PAGE_SLUG.INTEREST_FORM
    | PAGE_SLUG.RECALL
    | PAGE_SLUG.SALES_WALL_PHONE
    | PAGE_SLUG.SALES_WALL_ACCESSORY
    | PAGE_SLUG.OFFER_WALL
    | PAGE_SLUG.HOTSPOT
    | PAGE_SLUG.ODR_WALL
    | PAGE_SLUG.KIDS_WATCH;

export const partials = {
    MARKETING: {
        ELIGIBILITY_26_YEAR_OLD: '/partials/fai/post-elig-bts-26',
        ELIGIBILITY_FTTH: '/partials/fai/post-elig-emerch-ftth',
        ELIGIBILITY_PACK: '/partials/fai/offres-pack',
        PACK_PS4_RECOMMERCE: '/partials/combo/detailproduit-reprise-ps4',
        FAI_BOTTOM_CONTENT: '/partials/mobiles/sas/contenu',
        FAI_COMMITMENTS: '/partials/fai/engagements',
        FAI_COMMITMENTS_WIFI5: '/partials/fai/engagements-wifi5',
        FAI_CONTENT: '/partials/fai/contenu',
        FAI_HOME_SLIDER: '/partials/banners/Home-fai_slider',
        FAI_PACK: '/partials/fai/pack',
        FAI_WIFI: '/partials/fai/wifi-num-1',
        FAI_PERFORMANCE: '/partials/data-performance-fai',
        FAI_PERFORMANCE_DATA: 'data-performance-fai',
        FAI_PRESENTATION_BYOU: '/partials/byou/presentation-fai',
        FAI_EXTRA_BBOX: '/partials/fai/extra-bbox',
        FAI_APP_BOUYGUES: '/partials/fai/app-bouygues',
        FAI_EXTRA_BBOX_PACK: '/partials/fai/extra-bbox-pack',
        OFFER_WALL_SLIDER: '/partials/banners/Home-mobile_slider',
        PACK_TABLET: '/partials/ec/zone_panier_bbox_tablette',
        PLAN_EUROPE: '/partials/mobiles/banniere_forfaits-mobiles_destinations_europe',
        PLAN_INTERNATIONAL: '/partials/mobiles/banniere_forfaits-mobiles_destinations',
        PROMO_INFOGRAPHIE: '/partials/mixte/infographie-top',
        PROMO_PRESENTATION: '/partials/mixte/presentation-top',
        PROMO_STORYTELLING: '/partials/mixte/presentation-storytelling',
        FORFAIT_MOINS_26: '/partials/mobiles/forfaitmoins26',
        KIDS_WATCH: '/partials/mobiles/kidswatch',
        SALES_DISABLED: '/partials/mobiles/soldes/contenu',
        PRODUCT_SPEC: (slug: string) => `/partials/products/${slug}/recap`,
        KIDS_WATCH_HERO: '/partials/kids-watch/hero',
        KIDS_WATCH_CONTENT: '/partials/kids-watch/contenu',
        KIDS_WATCH_VIDEO: '/partials/kids-watch/video',
    },
    SEO: {},
    FAQ: (slug: FaqSlugType) => `/partials/faq/emplacements/${slug}`,
    BANNER: (slug: BannerSlugType) => `/partials/bandeau/${slug}`,
    LEGALS: (slug: LegalsSlugType) => `/partials/mentions_legales/emplacements/${slug}`,
    HEADER: {
        ACQ: appConfig.assets.partials.header.default,
        RNW: appConfig.assets.partials.header.renewal,
        LIGHT: appConfig.assets.partials.header.light,
    },
    FOOTER: {
        ACQ: '/partials/v3/footer',
        LIGHT: '/partials/v3/footer/light',
    },
};
